/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type CeilingInsulationEnum = 1 | 2 | 3;

export const CeilingInsulationEnum = {
    NUMBER_1: 1 as CeilingInsulationEnum,
    NUMBER_2: 2 as CeilingInsulationEnum,
    NUMBER_3: 3 as CeilingInsulationEnum
};

